const getEntities = (list, addToList, userId = null) => {
	list.forEach((item) => {
		if (item?.isEnabled) {
			if (userId === null) addToList([item]);
			if (item.entityAdmins.some((admins) => admins.userId === userId)) addToList([item]);
		}
		if (item?.nodes?.length > 0) getEntities(item.nodes, addToList, userId);
	});
};

const mapEntities = ({label, id, entityId, entityAdmins, contacts}) => ({
	label,
	value: id,
	id,
	entityId,
	entityAdmins,
	selected: false,
	disabled: false,
	contacts
});

const getAvailableEntityList = (list, mapped = true, userId = null) => {
	const newList = [];
	const addToList = (itemsToAdd) => newList.push(...itemsToAdd);
	getEntities(list, addToList, userId);
	return mapped ? newList.map(mapEntities) : newList;
};

export const getEntityIndeterminateState = (list, selectedUsers) =>
	list.map((item) => {
		const selectedFromEntity = item.contacts?.filter(({userId}) =>
			selectedUsers.some((selected) => userId === selected.userId)
		);
		if (selectedFromEntity.length === selectedUsers.length)
			return {...item, selected: true, checked: true, indeterminate: false};
		if (selectedFromEntity.length > 0) return {...item, selected: true, checked: true, indeterminate: true};
		return {...item, selected: false, checked: false, indeterminate: false};
	});

export const getAdminAvailableEntityList = (list, userId) => {
	return getAvailableEntityList(list, true, userId);
};

export default getAvailableEntityList;
